import script from "./TimeSlider.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimeSlider.vue?vue&type=script&lang=ts&setup=true"

import "./TimeSlider.vue?vue&type=style&index=0&id=20577bfa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20577bfa"]])

export default __exports__